exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SlideWithImage{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.SlideWithImage.left-image{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.SlideWithImage.left-image .slide-img{margin-right:4em}.SlideWithImage.right-image .slide-img{margin-left:4em}.SlideWithImage .slide-img{margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/sass-loader/lib/loader.js!./src/components/contents/SlideWithImage/SlideWithImage.m.scss
// module id = 1140
// module chunks = 17